import React from 'react'
import { useSelector } from 'react-redux'
import { componentKey as DataLoaderComponentKey } from '../../loaders/dataloader/DataLoaderSlice'

export function useUserPermissionsInfo() {
    const { permissions } = useSelector((state) => state[DataLoaderComponentKey])

  return {
      permissions
  }

}

export const isAccessAllowed = (toCheck, permissions = {}) => {
    if(Object.keys(permissions).length === 0){
        const dashboardSlice = useSelector((state) => state[DataLoaderComponentKey])
        permissions = dashboardSlice.permissions
    }

    if(!toCheck || toCheck.length === 0) {
        return true;
    }

    for(let permission of toCheck) {
        if(!permissions[permission]) {
            return false;
        }
    }

    return true;
}

export const PermissionReroute = (toCheck, permissions, navigate, destination) =>{
    if(Object.keys(permissions).length !== 0 && !isAccessAllowed(toCheck, permissions)) {
        navigate(destination)
    }
}